export default __webpack_public_path__ + "static/media/3.c2873002.jpg";